import { enableClickable } from './clickable-attribute';
import { enableFormAttributes } from './form-attribute';
import { enableAlerts } from './alerts-attribute';

export function initializeBehaviors(){
    if (window.pageBehaviors)
    {               
        if (window.pageBehaviors.useClickable === true) {
            enableClickable();
        }                     
        if (window.pageBehaviors.useFormAttributes == true){
            enableFormAttributes();
        }
        if (window.pageBehaviors.useAlerts == true) {
            enableAlerts();
        }
    }
    else{
        // Default behaviors      
        enableClickable();
    }

}